var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_565526",
    clipPath: "url(#clip0_13815_25191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.76172 3.40479V6.02382L8.00361 7.3543L8.38075 6.71787L6.54743 5.63096V3.40479H5.76172Z",
    fill: "#97A6A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.28309 0.785706C3.67714 0.785706 1.57143 2.89665 1.57143 5.49999H0L2.04023 7.54022L2.07689 7.61616L4.19048 5.49999H2.61906C2.61906 3.47548 4.2612 1.83333 6.28571 1.83333C8.31023 1.83333 9.95237 3.47548 9.95237 5.49999C9.95237 7.52451 8.31023 9.16665 6.28571 9.16665C5.27214 9.16665 4.35809 8.75285 3.69548 8.09022L2.95429 8.83142C3.80548 9.68522 4.98143 10.2143 6.28309 10.2143C8.88906 10.2143 11 8.10333 11 5.49999C11 2.89665 8.88906 0.785706 6.28309 0.785706Z",
    fill: "#97A6A5"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13815_25191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.848c839c2d674ecbd06bfa0d430aad36.svg";
export { ForwardRef as ReactComponent };